module.exports = __webpack_public_path__ + "img/canceled-clock-alert-outline.ff736a15.svg";